/**
 * Breakpoint constants matching Bootstrap 4 standard
 * These values should match the breakpoints defined in src/assets/css/general/settings.scss
 */
const BREAKPOINTS = {
    XS: 575,
    SM: 767,
    MD: 991,
    LG: 1199,
    XL: 1399,
};

export const SCREEN_XS = BREAKPOINTS.XS;
export const SCREEN_SM = BREAKPOINTS.SM;
export const SCREEN_MD = BREAKPOINTS.MD;
export const SCREEN_LG = BREAKPOINTS.LG;
export const SCREEN_XL = BREAKPOINTS.XL;




// WEBPACK FOOTER //
// ./src/constants/breakpoints.js